
import { useMemo } from 'react';
import { motion } from 'framer-motion';

type Star = {
  id: number;
  top: string;
  left: string;
  size: number;
  delay: number;
  duration: number;
  opacity: number;
};

function buildStars(count: number): Star[] {
  return Array.from({ length: count }, (_, id) => ({
    id,
    top: `${8 + ((id * 37) % 84)}%`,
    left: `${4 + ((id * 53) % 92)}%`,
    size: id % 5 === 0 ? 2.5 : id % 3 === 0 ? 1.8 : 1.2,
    delay: (id % 7) * 0.35,
    duration: 2.4 + (id % 5) * 0.6,
    opacity: 0.18 + (id % 4) * 0.12,
  }));
}

export default function AdminStarsLayer() {
  const stars = useMemo(() => buildStars(48), []);

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      {stars.map((star) => (
        <motion.span
          key={star.id}
          className="absolute rounded-full bg-white"
          style={{
            top: star.top,
            left: star.left,
            width: star.size,
            height: star.size,
            boxShadow: `0 0 ${star.size * 3}px rgba(186, 230, 253, 0.35)`,
          }}
          initial={{ opacity: star.opacity * 0.4 }}
          animate={{ opacity: [star.opacity * 0.35, star.opacity, star.opacity * 0.4] }}
          transition={{
            duration: star.duration,
            delay: star.delay,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
      ))}
    </div>
  );
}
